import { readable } from 'svelte/store';
import firebase from 'firebase';
import {persistStorage} from "../lib/persistStorage";

export const firebaseUser = readable(undefined, set => {
  return firebase.auth().onAuthStateChanged(set);
});


export const signOut = () => {
  firebase.auth().signOut().then(() => persistStorage.clear());
};